<template>
  <IAmOverlay
    :loading="loadingUpdateCount"
    :spinner-variant="'info'"
  >
    <b-row>
      <b-col
        cols="12"
        class="d-flex-center gap-3"
      >
        <b-form-group
          v-for="item of paxOptions"
          :key="item.label"
          :label="$t(`flight.${item.label}`)"
          :label-for="`fareType_${item.label}`"
        >
          <b-form-select
            :id="`fareType_${item.label}`"
            :value="paxCount(item.value)"
            class="fw-700 text-body font-medium-4"
            @change="count => updatePaxCountHandle(item.value, count)"
          >
            <b-form-select-option
              v-for="count of Array.from({ length: item.length }, (_,i) => i + item.addIndex)"
              :key="count"
              :value="count"
              :disabled="disabledCount(item.value, count)"
            >
              {{ count }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        sm="6"
      >
        <b-form-group
          :label="$t('flight.fareType')"
          label-for="fareType"
        >
          <b-form-select
            id="fareType"
            v-model="fareType"
            class="fw-700 text-body"
          >
            <b-form-select-option :value="null">
              {{ $t('flight.default') }}
            </b-form-select-option>
            <b-form-select-option
              v-for="item of fareTypeOptions"
              :key="item"
              :value="item"
            >
              {{ $t(`flight.searchClass.${item}`) }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        sm="6"
      >
        <b-form-group
          :label="$t('flight.currency')"
          label-for="currency"
        >
          <b-form-select
            id="currency"
            v-model="currency"
            class="fw-700 text-body"
          >
            <b-form-select-option value="VND">
              VND
            </b-form-select-option>
            <b-form-select-option value="USD">
              USD
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        sm="6"
      >
        <b-form-checkbox
          v-model="isBargainFinder"
          class="custom-control-warning"
          switch
        >
          <span class="text-nowrap font-medium-1 font-weight-bolder">
            <!-- {{ $t('reservation.bargainFinder') }} -->
            Tính giá rẻ nhất
          </span>
        </b-form-checkbox>
      </b-col>
      <b-col
        cols="12"
        sm="6"
      >
        <b-form-checkbox
          v-model="keepGroup"
          class="custom-control-warning"
          switch
        >
          <span class="text-nowrap font-medium-1 font-weight-bolder">
            Giữ hạng dịch vụ
          </span>
        </b-form-checkbox>
      </b-col>

      <b-col cols="12">
        <div class="d-flex align-items-center mt-75">
          <span class="mr-1 text-nowrap">
            {{ $t('applyDate') }}:
          </span>
          <flat-pickr
            v-model="dateIssue"
            class="d-none"
          />
          <flat-pickr
            id="calculate-dateIssue"
            v-model="dateIssue"
            class="form-control px-50 py-0 border"
            :config="{
                  ...configFlatPickr,
                  altInputClass: 'form-control input px-50 py-0',
            }"
            :placeholder="$t('applyDate')"
          />
        </div>
      </b-col>
    </b-row>

    <!-- ANCHOR - BUTTONs TÍNH GIÁ -->
    <div class="d-flex-center mt-50 pt-50 border-top">
      <b-button
        variant="warning"
        class="py-75"
        pill
        @click="calculatePriceHandle"
      >
        Tính giá vé
      </b-button>
    </div>
  </IAmOverlay>
</template>

<script>
import {
  BRow, BCol, BButton,
  BFormGroup, BFormSelectOption,
  BFormSelect, BFormCheckbox,
} from 'bootstrap-vue'
import {
  computed,
  ref,
  // onBeforeUpdate,
} from '@vue/composition-api'
import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import VueI18n from 'vue-i18n'

import useClassBookingPro from './useClassBookingPro'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    BFormGroup,
    BFormSelectOption,
    BFormSelect,
    flatPickr,
    IAmOverlay: () => import('@/components/IAmOverlay.vue'),
  },
  setup() {
    // onBeforeUpdate(() => {
    //   console.log("UPDATE'ClassBookingProBookCalculate' ")
    // })

    const {
      currency,
      fareType,
      isBargainFinder,
      keepGroup,
      dateIssue,
      paxCount,
      updatePaxCount,
      calculatePriceHandle,
    } = useClassBookingPro()

    const paxOptions = [
      {
        label: 'Adult',
        value: 'ADULT',
        length: 9,
        addIndex: 1,
      },
      {
        label: 'Child',
        value: 'CHILD',
        length: 10,
        addIndex: 0,
      },
      {
        label: 'Infant',
        value: 'INFANT',
        length: 10,
        addIndex: 0,
      },
    ]

    const fareTypeOptions = ['M1B', 'CRF', 'NRF']
    const currencyOptions = ['VND', 'USD']

    function disabledCount(paxType, value) {
      if (paxType === 'ADULT') {
        return value + paxCount('CHILD') > 9
      }
      if (paxType === 'CHILD') {
        return value + paxCount('ADULT') > 9
      }
      if (paxType === 'INFANT') {
        return value > paxCount('ADULT')
      }
      return true
    }

    const loadingUpdateCount = ref(false)

    async function updatePaxCountHandle(paxType, count) {
      loadingUpdateCount.value = true

      setTimeout(() => {
        updatePaxCount(paxType, count)
        loadingUpdateCount.value = false
      }, 100)
    }

    const locale = computed(() => VueI18n.locale).value

    const configFlatPickr = ref({
      dateFormat: 'Y-m-d',
      minDate: 'today',
      // maxDate: 'today',
      locale: locale === 'vi' ? Vietnamese : null,
      allowInput: true,
      altInput: true,
      altFormat: 'd-m-Y',
      shorthandCurrentMonth: true,
      disableMobile: true,
    })

    return {
      loadingUpdateCount,
      currency,
      fareType,
      keepGroup,
      paxOptions,
      fareTypeOptions,
      currencyOptions,
      isBargainFinder,
      configFlatPickr,
      dateIssue,
      paxCount,
      disabledCount,
      updatePaxCount,
      calculatePriceHandle,
      updatePaxCountHandle,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

</style>
